(() => {
  const SELECTOR = '.foam-calc[data-section-id]';

  function toNum(v){ const n = Number(v); return Number.isFinite(n) ? n : 0; }
  function clamp(n,min,max){ return Math.min(Math.max(n,min),max); }

  function initSection(section){
    if (!section || section.dataset.initialized) return;
    section.dataset.initialized = 'true';

    const sectionId = section.getAttribute('data-section-id');
    const cover = toNum(section.getAttribute('data-coverage-per-can-at-1in')) || 20;
    const rPerInch = toNum(section.getAttribute('data-r-per-inch')) || 4.12;

    // scoped elements
    const len = section.querySelector(`#foamLen-${sectionId}`);
    const ht  = section.querySelector(`#foamHt-${sectionId}`);
    const thk = section.querySelector(`#foamThk-${sectionId}`);

    const outArea = section.querySelector(`#foamArea-${sectionId}`);
    const outCans = section.querySelector(`#foamCans-${sectionId}`);
    const outR    = section.querySelector(`#foamR-${sectionId}`);

    const limits = {
      [len?.id]: [0,100000],
      [ht?.id]:  [0,100000],
      [thk?.id]: [0,1000]
    };

    function sanitize(el){
      if (!el) return 0;
      const [min,max] = limits[el.id] || [0, Infinity];
      let n = clamp(toNum(el.value), min, max);
      if (el.value !== String(n)) el.value = n;
      return n;
    }

    function calc(){
      const L = sanitize(len);
      const H = sanitize(ht);
      const T = sanitize(thk);

      const area = L * H;
      const cansExact = area * T / cover;
      const cans = Math.ceil(cansExact || 0);
      const rvalue = T * rPerInch;

      if (outArea) outArea.textContent = (Number.isFinite(area) ? area : 0).toFixed(2);
      if (outCans) outCans.textContent = String(cans);
      if (outR)    outR.textContent    = (Number.isFinite(rvalue) ? rvalue : 0).toFixed(2);
    }

    [len, ht, thk].forEach(el => {
      if (!el) return;
      el.addEventListener('input', calc, { passive:true });
      el.addEventListener('change', calc);
      el.addEventListener('keydown', e => {
        if (['e','E','+','-'].includes(e.key)) e.preventDefault();
      });
      el.addEventListener('wheel', () => el.blur(), { passive:true });
    });

    calc();
  }

  function initAll(){
    document.querySelectorAll(SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme Editor içinde canlı ekleme-silme desteği
  document.addEventListener('shopify:section:load', e => {
    const el = e.target && e.target.querySelector(SELECTOR);
    if (el) initSection(el);
  });

  document.addEventListener('shopify:section:unload', e => {
    const el = e.target && e.target.querySelector(SELECTOR);
    if (el && el.dataset) delete el.dataset.initialized;
  });
})();
